export enum AnalysisSetLinkTypesEnum {
SourcedFrom = "AS_LNK_SOURCED_FROM",
CreatedFrom = "AS_LNK_CREATED_FROM",
}